export const SET_CURRENT_ANSWER = 'SET_CURRENT_ANSWER';
export const SET_ANSWERS = 'SET_ANSWERS';
export const ADD_ANSWER = 'ADD_ANSWER';
export const UPDATE_ANSWER_IN_CACHE = 'UPDATE_ANSWER_IN_CACHE';
export const CLEAR_ANSWERS_CACHE = 'CLEAR_ANSWERS_CACHE';
